type NamedResource = {
  __typename?: string | null;
  name?: string | null;
  displayName?: string | null;
};

export const getResourceName = (
  resource: NamedResource | null | undefined
): string | undefined =>
  (resource?.__typename === 'Account'
    ? resource.displayName
    : resource?.name) ?? undefined;
